// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Inbox-container-llhvx {
  margin: 0 auto;
  max-width: var(--max-content-width);
  padding-top: 30px;
}`, "",{"version":3,"sources":["webpack://./src/routes/inbox/Inbox.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mCAAmC;EACnC,iBAAiB;AACnB","sourcesContent":[".container {\n  margin: 0 auto;\n  max-width: var(--max-content-width);\n  padding-top: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Inbox-container-llhvx`
};
module.exports = ___CSS_LOADER_EXPORT___;
